module.exports = __webpack_public_path__ + "img/retis.bee41a6d.png";